export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.27-1342.16",
  commitId: "4234b02cc98b3fbfe157a5e00fff7e179f8a8ae1",
  commitTime: "2026-07-27T13:42:16.000Z",
});
